const sharedMutations = []

// auth
export const _AUTH__SET_EMAIL = '_AUTH__SET_EMAIL'
sharedMutations.push(_AUTH__SET_EMAIL)
export const _AUTH__SAVE_AUTH = '_AUTH__SAVE_AUTH'
sharedMutations.push(_AUTH__SAVE_AUTH)

// scripts
export const _SCRIPTS__SAVE = '_SCRIPTS__SAVE'
sharedMutations.push(_SCRIPTS__SAVE)
export const _SCRIPTS__SAVE_ONE = '_SCRIPTS__SAVE_ONE'
sharedMutations.push(_SCRIPTS__SAVE_ONE)
export const _SCRIPTS__SORT = '_SCRIPTS__SORT'
export const _SCRIPTS__SAVE_CARDS = '_SCRIPTS__SAVE_CARDS'
export const _SCHEME__COLLAPSE_OPTION = '_SCHEME__COLLAPSE_OPTION'
export const _SCHEME__RESTORE_COLLAPSE_OPTION =
  '_SCHEME__RESTORE_COLLAPSE_OPTION'
export const _SCHEME__UPDATE = '_SCHEME__UPDATE'
export const _SCHEME__CURRENT_TEST = '_SCHEME__CURRENT_TEST'
export const _SCHEME__REMOVE_VARIANT = '_SCHEME__REMOVE_VARIANT'
export const _SCRIPTS__SAVE_CARD_OPTION = '_SCRIPTS__SAVE_CARD_OPTION'
export const _SCRIPTS__REMOVE_CARD_OPTION = '_SCRIPTS__REMOVE_CARD_OPTION'

export const SHAREABLE_MUTATIONS = sharedMutations
